import React from "react"
import PropTypes from "prop-types"

const CollapsibleSection = ({
  name,
  count,
  isExpanded,
  isLoading,
  onToggle,
  onRefresh,
  children,
  id
}) => (
  <div className="mt-4" id={id}>
    <div className="custom-expand-collapse px-3 py-2">
      <div
        role="button"
        tabIndex={0}
        className="expand-collapse-label flex-grow-1 d-flex align-items-center"
        onClick={onToggle}
        onKeyDown={e => e.key === "Enter" && onToggle()}
        style={{ cursor: "pointer", userSelect: "none" }}>
        <h3 className="mb-0 text-dark" style={{ fontSize: "1.25rem", fontWeight: "600" }}>
          {name}
          <span className="ml-2 text-muted" style={{ fontSize: "1rem", fontWeight: "normal" }}>
            (
            {count}
            )
          </span>
        </h3>
      </div>
      <div className="d-flex align-items-center expand-collapse-action-buttons">
        {onRefresh && (
          <button
            type="button"
            className={`btn btn-link expand-collapse-button ${isLoading ? "loading" : ""} p-0 mr-3`}
            onClick={e => {
              e.stopPropagation()
              onRefresh()
            }}
            title="Refresh data"
            style={{ marginTop: "2px" }}
            disabled={isLoading}>
            <i className="bi bi-arrow-repeat" style={{ color: "#042464" }}></i>
          </button>
        )}
        <span
          className={`expand-collapse-icon ${isExpanded ? "expanded" : "collapsed"} text-muted`}
          onClick={onToggle}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === "Enter" && onToggle()}>
          ▼
        </span>
      </div>
    </div>
    {isExpanded && (
      <div className="expand-collapse-content">
        {isLoading && (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!isLoading && children}
      </div>
    )}
  </div>
)

CollapsibleSection.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  children: PropTypes.node,
  id: PropTypes.string
}

CollapsibleSection.defaultProps = {
  isLoading: false,
  onRefresh: null,
  children: null,
  id: null
}

export default CollapsibleSection
